import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../lib/api';

/**
 * PlanChatRedirect — `/plan/:id/chat` is the user-facing URL, but the underlying
 * conversation is just a group chat with `kind='plan'`. We get-or-create the
 * linked group and redirect to `/groups/<group_id>` so all richer chat features
 * (reactions, voice, delete, typing) work uniformly.
 */
export default function PlanChatRedirect() {
  const { id: planId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/plans/${planId}/group-chat`);
        if (!cancelled && data?.group_id) {
          navigate(`/groups/${data.group_id}`, { replace: true });
          return;
        }
      } catch {/* fallthrough */}
      if (!cancelled) navigate(`/plan/${planId}`, { replace: true });
    })();
    return () => { cancelled = true; };
  }, [planId, navigate]);

  return (
    <div className="fixed inset-0 bg-[#FAFAF5] flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-[#9B9EA3] border-t-[#111] rounded-full animate-spin" />
    </div>
  );
}
